import { afterLoadIdle } from "./afterLoadIdle";

let chatChunkPrefetched = false;

export const prefetchChatChunk = (): void => {
  if (chatChunkPrefetched) return;
  chatChunkPrefetched = true;
  import("../../routes/newTrip/newTrip");
  // ChatEntryContent's on-demand result lists, fetched after load +
  // idle so they never compete with the first screen.
  const warm = () => {
    import("../../component/reusableComponent/flight/FlightSearchResults");
    import("../../component/reusableComponent/hotel/HotelSearchResults");
  };
  afterLoadIdle(warm);
};
